import { FiGlobe } from 'react-icons/fi';
import { DomainsPage } from './index';
import { DomainDetails } from './DomainDetails';

export const moduleConfig = {
  id: 'domains',
  name: 'Domains',
  description: 'Domain registration and DNS management',
  icon: FiGlobe,
  color: 'purple',
  path: '/domains',
  version: '1.0.0',
  permissions: ['TENANT_USER', 'TENANT_ADMIN'],
  subscriptionTiers: ['BASIC', 'PREMIUM', 'ENTERPRISE'],
  routes: [
    {
      path: '/domains/:id',
      component: DomainDetails,
      permissionLevel: 'view',
      useLayout: true,
    },
    {
      path: '/domains',
      component: DomainsPage,
      permissionLevel: 'view',
      useLayout: true,
    },
  ],
  navigation: {
    main: {
      label: 'Domains',
      path: '/domains',
      icon: FiGlobe,
    },
    sub: [
      {
        label: 'Search Domains',
        path: '/domains',
        description: 'Search and register new domains',
      },
      {
        label: 'My Domains',
        path: '/domains#my-domains',
        description: 'Manage your registered domains',
      },
      {
        label: 'DNS Management',
        path: '/domains#dns',
        description: 'Configure DNS records',
      },
      {
        label: 'Email Setup',
        path: '/domains#email',
        description: 'Configure email for your domains',
      },
    ],
  },
  features: [
    'Domain search and registration',
    'DNS record management',
    'Nameserver configuration',
    'WHOIS privacy protection',
    'Domain transfer',
    'Auto-renewal',
    'Email configuration',
    'SSL certificates',
    'Crypto payment support',
  ],
  settings: {
    enableCryptoPayments: true,
    enableAutoRenew: true,
    enablePrivacyProtection: true,
    enableDNSSEC: false,
    defaultTTL: 3600,
    providers: ['vercel', 'cloudflare', 'resellerclub'],
  },
  changelog: [
    {
      version: '1.0.0',
      releaseDate: '2025-11-22',
      title: 'Stable Release - Production Ready',
      features: [
        '✅ Production-ready domain management platform',
        '✅ Domain search and registration',
        '✅ Comprehensive DNS record management',
        '✅ Nameserver configuration',
        '✅ WHOIS privacy protection',
        '✅ Email configuration for domains',
        '✅ SSL certificate management',
        '✅ Crypto payment support',
        '✅ Auto-renewal capabilities'
      ],
      notes: 'Official stable release with comprehensive domain management features.'
    },
    {
      version: '0.3.0',
      releaseDate: '2025-09-20',
      title: 'Theme System Migration',
      features: [
        '✨ Full light/dark mode support (58 lines)',
        '✨ Enhanced DomainDetails theme awareness (34 lines)',
        '✨ Updated domain list color modes (24 lines)',
        '✨ Consistent visual design system'
      ],
      notes: 'Complete theme system implementation for better user experience.'
    },
    {
      version: '0.2.0',
      releaseDate: '2025-08-25',
      title: 'Enhanced Domain Details & Documentation',
      features: [
        '✅ Created DomainDetails component (670 lines)',
        '✅ Created comprehensive README (217 lines)',
        '✨ Enhanced domain management UI (950 insertions)',
        '✨ DNS record editing capabilities',
        '✨ Domain transfer functionality',
        '✨ Better domain status tracking'
      ],
      notes: 'Domain details and documentation improvements.'
    },
    {
      version: '0.1.0',
      releaseDate: '2025-08-25',
      title: 'Initial Domain Management System',
      features: [
        '✅ Created domain search interface (545 lines)',
        '✅ Created reseller guide (213 lines)',
        '✅ Domain availability checking',
        '✅ Registration workflow',
        '✅ Pricing and TLD support',
        '✅ ResellerClub integration',
        '✅ Native Date formatting'
      ],
      notes: 'Initial implementation with 758 lines of domain management code.'
    }
  ],
  roadmap: []
};